/**
 * 线上发布
 */
// 默认title
export const DEFAULT_TITLE = '萝卜丝'
//
export const HTTP_CLIENT = 'web'
// export const HTTP_CLIENT = 'mac'
// export const HTTP_CLIENT = 'windows'
// export const HTTP_CLIENT = 'linux'
// i18n默认语言
export const I18N_DEFAULT_LOCAL = 'zh'
// 是否固定标题
export const FIX_TITLE = false
// 判断是否为客户端
export const IS_ELECTRON = false
// 线上环境
export const IS_PRODUCTION = true
// 是否显示右下角按钮
export const SHOW_BOTTOM_RIGHT_BUTTONS = true
// 线上版本
// 私有部署验证
export const IS_PRIVATE_SERVER = false
export const PRIVATE_SERVER_UID = ''
export const PRIVATE_SERVER_VALIDEDATE = '2022-09-01 00:00:00'
// 是否为大学长定制
export const IS_DAXUEZHANG = false
export const IS_IP = false
export const HTTP_PREFIX = 'https://'
// 统计数据
export const SHOW_STATISTIC = true
// 帮助中心
export const SHOW_SUPPORT = true
// 意见反馈
export const SHOW_FEEDBACK = true
// 管理后台
export const ADMIN_URL = '../admin/#/antv/dashboard/workplace'
// 登录页面
export const LOGIN_URL = '../admin/#/antv/user/login'
// 单独聊天窗口
export const CHAT_BASE_URL = '/chat'
// 管理后台baseUrl
export const ADMIN_BASE_URL = '../admin/#'
// 主页网站
export const HOME_URL = 'https://www.bytedesk.com'
// 官方帮助首页
export const HELP_URL = 'https://vip.docs.bytedesk.com'
// 帮助页面base url
// export const HELP_BASE_URL = 'https://support.bytedesk.com/support/article?uid=201808221551193&aid='
// mq websocket
export const MQ_WEBSOCKET_ENDPOINT = 'ws://api.bytedesk.com =15674/ws'
// websocket
export const WEBSOCKET_ENDPOINT = 'wss://api.bytedesk.com/stomp?access_token='
// websocket
export const SOCKJS_WEBSOCKET_ENDPOINT = 'https://api.bytedesk.com/stomp?access_token='
// 跳转到微信公众号授权页面
export const WECHAT_OPEN_PLATFORM_REDIRECT_URI = 'https://wechat.bytedesk.com/redirect/'
// 私有部署服务器验证url
export const PRIVATE_SERVER_VALIDATE_URL = 'https://api.bytedesk.com/visitor/api/server/validate'
// restapi 发布
// AXIOS_DEFAULT_BASEURL = '/'
// export const AXIOS_DEFAULT_BASEURL = 'https://api.bytedesk.com/'
export const AXIOS_DEFAULT_BASEURL = 'https://api.bytedesk.com/'
// 是否显示im对话框
export const SHOW_IM = true
// 上传文件3-上传所有类型合体
export const UPLOAD_FILE_URL_V3 = 'https://upload.bytedesk.com/visitor/api/v3/upload/file'
// 上传表情
export const UPLOAD_EMOJI_URL = 'https://upload.bytedesk.com/visitor/api/v2/upload/emoji'
// 上传图片2
export const UPLOAD_IMAGE_URL_V2 = 'https://upload.bytedesk.com/visitor/api/v2/upload/image'
// 上传文件2
export const UPLOAD_FILE_URL_V2 = 'https://upload.bytedesk.com/visitor/api/v2/upload/file'
// 上传头像
export const UPLOAD_AVATAR_URL = 'https://upload.bytedesk.com/visitor/api/upload/avatar'
// 上传图片
export const UPLOAD_IMAGE_URL = 'https://upload.bytedesk.com/visitor/api/upload/image'
// 上传录音
export const UPLOAD_VOICE_URL = 'http://upload.bytedesk.com/visitor/api/upload/voice'
// 上传视频
export const UPLOAD_VIDEO_URL = 'http://upload.bytedesk.com/visitor/api/upload/video'
// 上传文件
export const UPLOAD_FILE_URL = 'https://upload.bytedesk.com/visitor/api/upload/file'
// 上传图片
export const UPLOAD_LAYIM_IMAGE_URL = 'https://upload.bytedesk.com/visitor/api/upload/layim/image'
// 上传文件
export const UPLOAD_LAYIM_FILE_URL = 'https://upload.bytedesk.com/visitor/api/upload/layim/file'
// 上传微信图片
export const UPLOAD_WECHAT_IMAGE_URL = 'https://upload.bytedesk.com/visitor/api/upload/wechat/image'
// 上传微信语音文件
export const UPLOAD_WECHAT_VOICE_URL = 'https://upload.bytedesk.com/visitor/api/upload/wechat/voice'
// 上传微信视频
export const UPLOAD_WECHAT_VIDEO_URL = 'https://upload.bytedesk.com/visitor/api/upload/wechat/video'
// 上传微信缩略图
export const UPLOAD_WECHAT_THUMB_URL = 'https://upload.bytedesk.com/visitor/api/upload/wechat/thumb'
// 百度ueditor富文本编辑器
export const UEDITOR_SERVER_URL = 'https://cdn.bytedesk.com/visitor/api/upload/ueditor/config'
export const UEDITOR_HOME_URL = 'https://cdn.bytedesk.com/static/ueditor/'
//
export const MQTT_PORT = 3885
export const MQTT_WS_HOST = 'mqtt.bytedesk.com'
// 测试阿里云cdn websocket服务
export const MQTT_HOST = 'wss://mqtt.bytedesk.com/websocket'
